
export enum ConditionsV2EformsEnum {
    E_FORM_1,
    E_FORM_2,
    E_FORM_3,
    E_FORM_4,
    E_FORM_5,
    E_FORM_6,
    E_FORM_7,
    E_FORM_8,
    E_FORM_9,
    E_FORM_10,
    E_FORM_11,
    E_FORM_12,
    E_FORM_13,
    E_FORM_14,
    E_FORM_15,
    E_FORM_16,
    E_FORM_17,
    E_FORM_18,
    E_FORM_19,
    E_FORM_20,
    E_FORM_21,
    E_FORM_22,
    E_FORM_23,
    E_FORM_24,
    E_FORM_25,
    E_FORM_26,
    E_FORM_27,
    E_FORM_28,
    E_FORM_29,
    E_FORM_30,
    E_FORM_31,
    E_FORM_32,
    E_FORM_33,
    E_FORM_34,
    E_FORM_35,
    E_FORM_36,
    E_FORM_37,
    E_FORM_38,
    E_FORM_39,
    E_FORM_40,
    E_FORM_CEI,
    E_FORM_E1,
    E_FORM_E2,
    E_FORM_E3,
    E_FORM_E4,
    E_FORM_E5,
    E_FORM_E6,
    E_FORM_T01,
    E_FORM_T02,
    E_FORM_X01,
    E_FORM_X02
}
